

<div class="dialog-content">
  <div class="modal-header">
    <h2 mat-dialog-title class="modal-title">Send Quote Email</h2>
    <button mat-icon-button (click)="checkIfSentEmail()"><span class="material-symbols-outlined">close</span></button>
  </div>
  @if (showCloseWarning) {
    <div> 
      <p class="warning-text">Please click the "X" again if you'd like to close this window without sending your email.</p>
    </div>
  }
  <div class="email-form">
    <form [formGroup]="emailForm" (ngSubmit)="triggerEmail(emailForm)">
      <mat-form-field appearance="outline">
        <mat-label>{{ data?.defaultFieldData?.emailFieldLabel || 'Customer Email Address' }}</mat-label>
        <input matInput formControlName="customerEmailAddress" required [placeholder]="data?.defaultFieldData?.emailFieldPlaceholder ? data.defaultFieldData?.emailFieldPlaceholder : 'janedoe123@example.com'"/>
        @if (formControls.customerEmailAddress.errors?.required) {
          <mat-error>Required</mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ data?.defaultFieldData?.nameFieldLabel }}</mat-label>
        <input matInput formControlName="clientName" [placeholder]="data?.defaultFieldData?.nameFieldPlaceholder"/>
      </mat-form-field>

      @for (field of data?.additionalModalFields; track field) {
        @if (field.display === "true") {
          <mat-form-field appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [formControlName]="field.fieldName" [placeholder]="field.placeholder"/>
          </mat-form-field>
        }
      }
      <mat-form-field appearance="outline">
        <mat-label>{{ data?.defaultFieldData?.agentNotesFieldLabel }}</mat-label>
        <textarea matInput maxlength="500" formControlName="agentNotes" [placeholder]="data?.defaultFieldData?.agentNotesFieldPlaceholder"></textarea>
      </mat-form-field>
      
      <div class="button-container">
        @if (emailTriggerIsPending) {
          <mat-spinner diameter="30"></mat-spinner>
        } @else{
          <button class="submit-button" mat-raised-button color="primary" type="submit" [disabled]="emailForm.invalid">
            Send Email
          </button>
        }
      </div>
    </form>
  </div>
</div>
